import navigationOverhaulRelease from "../releases/2026.06-nav-overhaul";

/**
 * Monotonic release ordering for comparison. New releases append to this array.
 */
export const RELEASE_ORDER = Object.freeze([
  "2026.05-baseline",
  "2026.06-nav-overhaul",
]);

const RELEASE_MAP = Object.freeze({
  "2026.06-nav-overhaul": navigationOverhaulRelease,
});

export function getReleaseOrdinal(releaseId) {
  const index = RELEASE_ORDER.indexOf(releaseId);
  return index === -1 ? -1 : index;
}

export function compareReleaseIds(a, b) {
  return getReleaseOrdinal(a) - getReleaseOrdinal(b);
}

export function isReleaseNewerThan(releaseId, lastSeenReleaseId) {
  if (!lastSeenReleaseId) {
    return getReleaseOrdinal(releaseId) >= 0;
  }
  return compareReleaseIds(releaseId, lastSeenReleaseId) > 0;
}

export function getReleaseManifest(releaseId) {
  return RELEASE_MAP[releaseId] || null;
}

export function getCurrentReleaseManifest(currentReleaseId) {
  return getReleaseManifest(currentReleaseId);
}

export function getAllReleases() {
  return RELEASE_ORDER.map((releaseId) => ({
    releaseId,
    manifest: getReleaseManifest(releaseId),
  })).filter((entry) => entry.manifest);
}
